import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-refresh",
  "use": "icon-icon-refresh-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-refresh\"><path d=\"M801.702 576.912c-7.244 151.545-133.354 272.206-287.869 272.206-159.174 0-288.214-128.042-288.214-285.983 0-153.307 121.559-278.418 274.246-285.649v136.004l301.938-163.42-301.939-190.653v136.228c-198.15 7.328-356.512 169.039-356.512 367.433 0 203.081 165.9 367.697 370.557 367.697 199.994 0 362.973-157.195 370.303-353.863l-82.508 0.001zM801.702 576.912z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol